
import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import VideoGalleryNavbar from './components/VideoGalleryNavbar';
import VideoGalleryFooter from './components/VideoGalleryFooter';

const classVideos = [
  {
    id: 1,
    title: 'Cocktail Fundamentals Masterclass',
    category: 'Beginner',
    duration: '3:45',
    instructor: 'Bella',
    views: '2.4K',
    thumbnail: 'https://public.readdy.ai/ai/img_res/4a3ec43592eef5775d55b6108a802f39.jpg',
    description: 'Learn the essential techniques every home bartender needs — shaking, stirring, muddling, and proper pouring.',
  },
  {
    id: 2,
    title: 'Advanced Mixology Techniques',
    category: 'Advanced',
    duration: '5:20',
    instructor: 'Bella',
    views: '1.8K',
    thumbnail: 'https://readdy.ai/api/search-image?query=advanced%20cocktail%20making%20class%20with%20molecular%20mixology%20techniques%2C%20smoke%20infusion%20demonstration%2C%20professional%20bartender%20creating%20artistic%20cocktail%2C%20sophisticated%20bar%20laboratory%20setting%2C%20dramatic%20lighting%20with%20amber%20tones%2C%20premium%20spirits%20and%20specialized%20equipment&width=600&height=340&seq=vid-adv-001&orientation=landscape',
    description: 'Explore advanced techniques including infusions, homemade syrups, and molecular mixology secrets.',
  },
  {
    id: 3,
    title: 'Private One-on-One Session',
    category: 'Private',
    duration: '2:30',
    instructor: 'Bella',
    views: '956',
    thumbnail: 'https://readdy.ai/api/search-image?query=intimate%20private%20bartending%20lesson%20one%20on%20one%20training%20session%2C%20professional%20mixologist%20teaching%20single%20student%2C%20personalized%20cocktail%20instruction%2C%20luxury%20intimate%20bar%20setting%2C%20focused%20learning%20environment%2C%20warm%20ambient%20lighting&width=600&height=340&seq=vid-priv-001&orientation=landscape',
    description: 'See how our personalized training sessions are tailored to your specific goals and skill level.',
  },
  {
    id: 4,
    title: 'Hen\'s Party Experience',
    category: 'Groups',
    duration: '4:15',
    instructor: 'Bella',
    views: '3.2K',
    thumbnail: 'https://readdy.ai/api/search-image?query=glamorous%20hens%20party%20bachelorette%20cocktail%20class%2C%20group%20of%20women%20making%20colorful%20drinks%20together%2C%20pink%20and%20gold%20decorations%2C%20champagne%20celebration%2C%20fun%20festive%20atmosphere%2C%20elegant%20bar%20setting%20with%20confetti%2C%20sophisticated%20ladies%20night%20experience&width=600&height=340&seq=vid-hens-001&orientation=landscape',
    description: 'The ultimate celebration experience! Watch how we transform hen\'s parties into unforgettable cocktail adventures.',
  },
  {
    id: 5,
    title: 'Home Bar Service',
    category: 'Private',
    duration: '3:00',
    instructor: 'Bella',
    views: '1.5K',
    thumbnail: 'https://readdy.ai/api/search-image?query=romantic%20couple%20learning%20cocktail%20making%20at%20home%20with%20professional%20bartender%2C%20intimate%20cozy%20home%20bar%20setting%2C%20elegant%20couple%20enjoying%20private%20mixology%20lesson%2C%20sophisticated%20date%20night%20experience%2C%20warm%20ambient%20lighting%2C%20premium%20bar%20setup%20in%20residential%20space&width=600&height=340&seq=vid-home-001&orientation=landscape',
    description: 'We bring the full bar experience to your doorstep — perfect for date nights and special occasions.',
  },
  {
    id: 6,
    title: 'Corporate Team Building',
    category: 'Groups',
    duration: '4:45',
    instructor: 'Bella',
    views: '2.1K',
    thumbnail: 'https://readdy.ai/api/search-image?query=corporate%20team%20building%20cocktail%20event%2C%20business%20professionals%20making%20drinks%20together%20in%20competition%2C%20fun%20group%20activity%2C%20modern%20event%20space%20with%20elegant%20decor%2C%20team%20collaboration%20and%20celebration%2C%20professional%20atmosphere%20with%20warm%20lighting&width=600&height=340&seq=vid-corp-001&orientation=landscape',
    description: 'See how we turn corporate events into engaging team-building experiences with friendly competitions.',
  },
  {
    id: 7,
    title: 'Whiskey Cocktail Classics',
    category: 'Intermediate',
    duration: '6:10',
    instructor: 'Bella',
    views: '1.9K',
    thumbnail: 'https://readdy.ai/api/search-image?query=whiskey%20cocktail%20masterclass%20demonstration%2C%20bartender%20crafting%20old%20fashioned%20and%20manhattan%2C%20premium%20bourbon%20and%20rye%20bottles%2C%20elegant%20dark%20wood%20bar%20setting%2C%20amber%20liquid%20being%20poured%20over%20ice%2C%20sophisticated%20moody%20lighting%2C%20classic%20cocktail%20preparation&width=600&height=340&seq=vid-whisk-001&orientation=landscape',
    description: 'Master the art of whiskey cocktails — from the perfect Old Fashioned to a silky Manhattan.',
  },
  {
    id: 8,
    title: 'Tropical Tiki Creations',
    category: 'Intermediate',
    duration: '5:30',
    instructor: 'Bella',
    views: '2.7K',
    thumbnail: 'https://readdy.ai/api/search-image?query=tropical%20tiki%20cocktail%20class%20with%20colorful%20rum%20drinks%2C%20exotic%20garnishes%20and%20tiki%20mugs%2C%20bartender%20creating%20mai%20tai%20and%20pina%20colada%2C%20vibrant%20tropical%20bar%20setting%20with%20palm%20decorations%2C%20fresh%20fruits%20and%20flowers%2C%20fun%20festive%20atmosphere%20with%20warm%20lighting&width=600&height=340&seq=vid-tiki-001&orientation=landscape',
    description: 'Transport yourself to paradise with our tropical tiki cocktail workshop featuring rum-based classics.',
  },
  {
    id: 9,
    title: 'Mocktail Magic',
    category: 'Beginner',
    duration: '3:15',
    instructor: 'Bella',
    views: '1.3K',
    thumbnail: 'https://readdy.ai/api/search-image?query=elegant%20mocktail%20creation%20class%2C%20bartender%20making%20sophisticated%20non-alcoholic%20drinks%2C%20colorful%20fresh%20fruit%20juices%20and%20herbs%2C%20beautiful%20garnishes%2C%20inclusive%20cocktail%20experience%2C%20bright%20modern%20bar%20setting%2C%20healthy%20refreshing%20beverages%20being%20prepared&width=600&height=340&seq=vid-mock-001&orientation=landscape',
    description: 'Create stunning alcohol-free cocktails that are just as impressive and delicious as their spirited counterparts.',
  },
];

const categories = ['All', 'Beginner', 'Intermediate', 'Advanced', 'Private', 'Groups'];

export default function VideoGalleryPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [playingVideo, setPlayingVideo] = useState<number | null>(null);
  const [scrolled, setScrolled] = useState(false);
  const videoRefs = useRef<{ [key: number]: HTMLVideoElement | null }>({});

  const filteredVideos = activeCategory === 'All' 
    ? classVideos 
    : classVideos.filter(video => video.category === activeCategory);

  const handlePlay = (id: number) => {
    // Pause any currently playing video
    if (playingVideo !== null && playingVideo !== id && videoRefs.current[playingVideo]) {
      videoRefs.current[playingVideo]?.pause();
    }
    setPlayingVideo(id);
    videoRefs.current[id]?.play();
  };

  const handlePause = (id: number) => {
    setPlayingVideo(null);
    videoRefs.current[id]?.pause();
  };

  const handleVideoEnd = () => {
    setPlayingVideo(null);
  };

  useState(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen bg-stone-950">
      <VideoGalleryNavbar scrolled={scrolled} />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20luxurious%20cocktail%20bar%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20bokeh%20lights%20reflecting%20off%20crystal%20glasses%20and%20premium%20spirit%20bottles%2C%20elegant%20moody%20atmosphere%20with%20deep%20shadows%20and%20rich%20amber%20tones%2C%20cinematic%20wide%20angle%20photography&width=1920&height=800&seq=vidgal-hero-001&orientation=landscape"
            alt="Video gallery background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-stone-950/90 via-stone-950/80 to-stone-950"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-amber-500"></div>
            <span className="text-amber-400 text-xs font-semibold tracking-[0.25em] uppercase flex items-center gap-2">
              <i className="ri-video-line"></i>
              Video Library
            </span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-amber-500"></div>
          </div>
          <h1 className="text-5xl md:text-7xl font-display font-normal text-white mb-6 leading-tight">
            Explore Our <br />
            <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300">Class Collection</span>
          </h1>
          <p className="text-white/50 max-w-2xl mx-auto leading-relaxed text-lg">
            Watch previews of our cocktail classes and discover the perfect experience for you. From beginner basics to advanced techniques.
          </p>
        </div>
      </section>

      {/* Filter Navigation */}
      <section className="py-8 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeCategory === category
                    ? 'bg-gradient-to-r from-amber-400 to-yellow-300 text-stone-900 shadow-lg shadow-amber-500/20'
                    : 'bg-white/5 text-white/70 border border-white/10 hover:border-amber-500/30 hover:text-amber-300'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Video Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredVideos.map((video) => (
              <div
                key={video.id}
                className="group bg-stone-900/50 rounded-2xl overflow-hidden border border-white/5 hover:border-amber-500/20 transition-all duration-500 hover:shadow-2xl hover:shadow-amber-500/10"
              >
                {/* Video Thumbnail */}
                <div className="relative aspect-video overflow-hidden">
                  <video
                    ref={(el) => { videoRefs.current[video.id] = el; }}
                    className="w-full h-full object-cover"
                    poster={video.thumbnail}
                    onEnded={handleVideoEnd}
                    controls={playingVideo === video.id}
                    playsInline
                  >
                    <source src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" type="video/mp4" />
                  </video>

                  {/* Overlay when not playing */}
                  {playingVideo !== video.id && (
                    <>
                      <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-transparent to-stone-900/20"></div>
                      
                      {/* Play Button */}
                      <div 
                        className="absolute inset-0 flex items-center justify-center cursor-pointer"
                        onClick={() => handlePlay(video.id)}
                      >
                        <div className="relative">
                          <div className="absolute inset-0 w-16 h-16 rounded-full bg-amber-400/20 animate-ping opacity-0 group-hover:opacity-100 transition-opacity"></div>
                          <div className="relative w-16 h-16 rounded-full bg-white/95 flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                            <i className="ri-play-fill text-3xl text-stone-900 ml-1"></i>
                          </div>
                        </div>
                      </div>

                      {/* Category Badge */}
                      <div className="absolute top-4 left-4">
                        <span className="px-3 py-1.5 bg-gradient-to-r from-amber-400 to-yellow-300 text-stone-900 text-xs font-semibold rounded-full">
                          {video.category}
                        </span>
                      </div>

                      {/* Duration Badge */}
                      <div className="absolute bottom-4 right-4 px-3 py-1.5 bg-black/60 backdrop-blur-sm rounded-full text-white/90 text-xs font-medium flex items-center gap-1.5">
                        <i className="ri-time-line"></i>
                        {video.duration}
                      </div>
                    </>
                  )}

                  {/* Pause Button when playing */}
                  {playingVideo === video.id && (
                    <div 
                      className="absolute top-4 right-4 w-10 h-10 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center cursor-pointer hover:bg-black/80 transition-all z-10"
                      onClick={() => handlePause(video.id)}
                    >
                      <i className="ri-pause-line text-xl text-white"></i>
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-lg font-serif font-semibold text-white mb-2 group-hover:text-amber-300 transition-colors">
                    {video.title}
                  </h3>
                  <p className="text-white/50 text-sm mb-4 line-clamp-2 leading-relaxed">
                    {video.description}
                  </p>

                  {/* Instructor & Views */}
                  <div className="flex items-center justify-between pt-4 border-t border-white/10">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-amber-400 to-yellow-300 flex items-center justify-center">
                        <span className="text-stone-900 text-xs font-bold">B</span>
                      </div>
                      <span className="text-white/70 text-sm">{video.instructor}</span>
                    </div>
                    <div className="flex items-center gap-1.5 text-white/40 text-sm">
                      <i className="ri-eye-line"></i>
                      <span>{video.views} views</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Empty State */}
          {filteredVideos.length === 0 && (
            <div className="text-center py-20">
              <div className="w-20 h-20 rounded-full bg-white/5 flex items-center justify-center mx-auto mb-6">
                <i className="ri-video-off-line text-4xl text-white/30"></i>
              </div>
              <h3 className="text-xl font-serif text-white mb-2">No videos found</h3>
              <p className="text-white/50">Try selecting a different category</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 border-t border-white/10">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-display text-white mb-4">
            Ready to Start Your Mixology Journey?
          </h2>
          <p className="text-white/50 mb-8 max-w-2xl mx-auto">
            Book a class today and learn from the best. Whether you're a complete beginner or looking to refine your skills, we have the perfect experience for you.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/#classes"
              className="px-8 py-3.5 bg-gradient-to-r from-amber-400 to-yellow-300 text-stone-900 font-semibold rounded-full hover:from-amber-300 hover:to-yellow-200 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-amber-500/20 hover:shadow-amber-500/40 hover:scale-105"
            >
              View All Classes
            </Link>
            <Link
              to="/#booking"
              className="px-8 py-3.5 bg-white/10 text-white font-semibold rounded-full border border-white/20 hover:bg-white/20 hover:border-amber-500/30 transition-all cursor-pointer whitespace-nowrap"
            >
              Book Now
            </Link>
          </div>
        </div>
      </section>

      <VideoGalleryFooter />
    </div>
  );
}
